import React, { useState } from 'react';
import '../../assets/css/DrawingToolsMenu.css';
import { useLanguage } from '../hooks/LanguageContext';
import '@fortawesome/fontawesome-free/css/all.min.css';

const DrawingToolsMenu = ({
                              onSelectTool,
                              onClearSelection,
                              currentTool,
                              selectionMode,
                              onSelectionModeChange,
                          }) => {
    const { language } = useLanguage();
    const [menuOpen, setMenuOpen] = useState(true);

    const currentLang =
        language === 'en' || language === 'en-US' || language === 'en-GB' ? 'en' : 'ru';

    const t = {
        selectionSingle: { ru: 'Выбор: одиночный', en: 'Selection: single' },
        selectionMulti:  { ru: 'Выбор: множественный', en: 'Selection: multi' },
        rectangle:       { ru: 'Прямоугольник', en: 'Rectangle' },
        circle:          { ru: 'Круг', en: 'Circle' },
        lasso:           { ru: 'Лассо', en: 'Lasso' },
        clear:           { ru: 'Снять выделение', en: 'Clear selection' },
        collapse:        { ru: 'Свернуть', en: 'Collapse' },
        open:            { ru: 'Инструменты', en: 'Tools' },
    };
    const tr = (key) => t[key]?.[currentLang] || t[key]?.ru || key;

    const handleSelectToggle = () => {
        onSelectionModeChange(
            selectionMode === 'single' ? 'multi' : 'single'
        );

        if (currentTool !== 'select') {
            onSelectTool('select');
        }
    };

    const handleToolClick = (tool) => {
        onSelectTool(tool);
    };

    const isSelectActive = currentTool === 'select';

    return (
        <>
            {!menuOpen && (
                <div
                    className="drawing-tools-toggle"
                    onClick={() => setMenuOpen(true)}
                    title={tr('open')}
                >
                    {/* Заменено на иконку кисти */}
                    <i className="fas fa-paint-brush" />
                </div>
            )}

            <div className={`drawing-tools-menu ${menuOpen ? '' : 'collapsed'}`}>
                <div className="drawing-tools-header">
                    <button
                        className="drawing-tools-close"
                        onClick={() => setMenuOpen(false)}
                        title={tr('collapse')}
                    >
                        ✕
                    </button>
                </div>

                <div className="drawing-tools-buttons">

                    <button
                        className={`tool-button select-toggle-btn ${selectionMode === 'multi' ? 'multi-mode' : 'single-mode'}`}
                        onClick={handleSelectToggle}
                        title={selectionMode === 'single' ? tr('selectionSingle') : tr('selectionMulti')}
                    >
                        <div className="select-toggle-track">
                            <div className={`select-toggle-thumb ${selectionMode === 'multi' ? 'thumb-right' : 'thumb-left'}`}>
                                <i className={selectionMode === 'single' ? 'fas fa-mouse-pointer' : 'fas fa-arrows-alt'} />
                            </div>
                        </div>
                        <span className="tool-tooltip">
        {selectionMode === 'single' ? tr('selectionSingle') : tr('selectionMulti')}
    </span>
                    </button>

                    <div className="tool-divider" />

                    <button
                        className={`tool-button ${currentTool === 'rectangle' ? 'active' : ''}`}
                        onClick={() => handleToolClick('rectangle')}
                        title={tr('rectangle')}
                    >
                        {/* Пустой квадрат (контур) */}
                        <i className="far fa-square" />
                        <span className="tool-tooltip">{tr('rectangle')}</span>
                    </button>

                    <button
                        className={`tool-button ${currentTool === 'circle' ? 'active' : ''}`}
                        onClick={() => handleToolClick('circle')}
                        title={tr('circle')}
                    >
                        {/* Пустой круг (контур) */}
                        <i className="far fa-circle" />
                        <span className="tool-tooltip">{tr('circle')}</span>
                    </button>

                    <button
                        className={`tool-button ${currentTool === 'lasso' ? 'active' : ''}`}
                        onClick={() => handleToolClick('lasso')}
                        title={tr('lasso')}
                    >
                        {/* Иконка для рисования многоугольника (замена лассо) */}
                        <i className="fas fa-draw-polygon" />
                        <span className="tool-tooltip">{tr('lasso')}</span>
                    </button>

                    <div className="tool-divider" />

                    <button
                        className="tool-button clear-button"
                        onClick={onClearSelection}
                        title={tr('clear')}
                    >
                        {/* Крестик в круге */}
                        <i className="fas fa-times-circle" />
                        <span className="tool-tooltip">{tr('clear')}</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default DrawingToolsMenu;